export default __webpack_public_path__ + "static/media/5399.1f2f11ab.png";